exports.linkResolver = (doc) => {
  switch (doc.type) {
    case "team_page":
      return `/${doc.uid}`;

      case "city_page":
      return `/${doc.uid}`;

      case "testimonials_page":
      return `/${doc.uid}`;

      case "why_now_page":
      return `/${doc.uid}`;

      case "simple_page":
      return `/${doc.uid}`;

      case "home_page":
      return `/`;

    default:
      if (!doc.uid) return "/";
      return doc.uid;
  }
};